import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Moment } from "moment";
import moment from "moment";
import { LocaleConfig, LocaleService } from "ngx-daterangepicker-material";
import { Console } from 'console';
import { AuthService } from 'src/app/auth/auth.service';
import { Store,select} from '@ngrx/store';
import * as dateActions from "../../../ngrx/act.action";
@Component({
  selector: 'app-datetime-range-picker',
  templateUrl: './datetime-range-picker.component.html',
  styleUrls: ['./datetime-range-picker.component.scss']
})
export class DatetimeRangePickerComponent {
  moment = moment;
  calendarLocale: LocaleConfig;
  ranges: any;
  calendarPlaceholder: string;
  selectedRange: any;
  minDate: Moment;
  maxDate: Moment;
  @Output() dateRange = new EventEmitter<string>();
  calanderStartFromNow=false;
  label: any;
  @Input() set fromNow(val:boolean){
    if(val){
      this.calanderStartFromNow=val;
      this.selectedRange = { startDate: moment(), endDate: moment().add(15, 'minutes') };
      this.minDate = moment();
      this.maxDate = moment()
        .clone()
        .add(365, "day");
    }
  };
  constructor(public authService:AuthService, private store:Store,private cdr: ChangeDetectorRef) {
    this.selectedRange = { startDate: moment().subtract(15, 'minutes'), endDate: moment() };
    this.calendarLocale = {
      customRangeLabel: "Pick a date...",
      applyLabel: "Apply",
      clearLabel: "Clear",
      format: "DD/MM/YYYY - HH:mm:ss",
      daysOfWeek: ["su", "mo", "tu", "we", "th", "fr", "sa"],
      monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      firstDay: 1
    };
    let now = new Date();
    let start = moment(
      new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
    );
    let end = moment(start).add(1, "days").subtract(1, "seconds");
    this.ranges = {
      "Today": [moment().startOf('day'), moment().set({ hour: 23, minute: 59, second: 0 })],
      'Yesterday': [moment(start).subtract(1, 'days'), moment(end).subtract(1, 'days')],
      'Last 7 Days': [moment(start).subtract(6, 'days'), moment(end)],
      'Monthly': [moment(start).subtract(30, "days"), moment(end)],
      'Realtime': [moment().subtract(900, "seconds"), moment()],
    };;
    this.calendarPlaceholder = " ";
    this.minDate = moment("01/01/2001").utc();
    this.maxDate = moment()
      .clone()
      .add(2, "day");
  }
  private getNextSaturday() {
    const dayINeed = 6; // for Saturday
    const today = moment().isoWeekday();
    if (today <= dayINeed) {
      return moment().isoWeekday(dayINeed);
    } else {
      return moment()
        .add(1, "weeks")
        .isoWeekday(dayINeed);
    }
  }
  private getNextSunday() {
    const dayINeed = 7; // for Sunday
    const today = moment().isoWeekday();
    if (today <= dayINeed) {
      return moment().isoWeekday(dayINeed);
    } else {
      return moment()
        .add(1, "weeks")
        .isoWeekday(dayINeed);
    }
  }
     choosedDate(event) {
  
      if (!event || (!event.startDate && !event.endDate)) {
        // Clear button clicked
        console.log('Clear button clicked');
        this.selectedRange = {
          startDate: moment().subtract(15, 'minutes'),
          endDate: moment(),
          label: "Realtime"
        };
        this.dateRange.emit(this.selectedRange)
      } else {
        // Normal date range selection
        console.log("hello chodesdataa apply");
        let now = new Date();
        let start = moment(
          new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
        );

        let end = moment(start).add(1, "days").subtract(1, "seconds");
        this.ranges = this.calanderStartFromNow?{
          "Today": [moment().startOf('day'), moment().set({ hour: 23, minute: 59, second: 0 })],
          // 'Yesterday': [moment(start).subtract(1, 'days'), moment(end).subtract(1, 'days')],
          'A Week': [moment(), moment().add(7, 'days')],
          'A Month': [moment(), moment(end).add(30, "days")],
          // 'Realtime': [moment(), moment().add(900, "seconds")],
        }
        :{
          "Today": [moment().startOf('day'), moment().set({ hour: 23, minute: 59, second: 0 })],
          'Yesterday': [moment(start).subtract(1, 'days'), moment(end).subtract(1, 'days')],
          'Last 7 Days': [moment(start).subtract(6, 'days'), moment(end)],
          'Monthly': [moment(start).subtract(30, "days"), moment(end)],
          'Realtime': [moment().subtract(900, "seconds"), moment()],
        };
        this.selectedRange.label = this.label;
          this.dateRange.emit(this.selectedRange)
      }

      console.log("hello end",{s:this.selectedRange?.startDate.valueOf(), e:this.selectedRange?.endDate?.valueOf()});
  }


  datesUpdated(event) {

  }
  


  handleRangeClick($event){
    console.log($event, 'helll00000');
    this.label = $event?.label;
    if($event?.label=="Realtime"){
      console.log($event, 'helll00000');
      this.ranges = {...this.ranges,   Realtime: [moment().subtract(900, "seconds"), moment()]};
      // this.selectedRange = {...this.selectedRange, startDate: moment().subtract(15, 'minutes'), endDate: moment() };
    }
    else if($event?.label=="Today"){  // while reload when click on today it is not working so i added this and it is working
      const start = moment().startOf('day'); // 00:00:00
      const end = moment().set({ hour: 23, minute: 59, second: 0 }); // 23:59:00
      console.log(start ,'hellls,00000 start');
      console.log(end ,'hellls,00000 end');
     
      setTimeout(() => {
        this.ranges = {
          ...this.ranges,
          Today: [moment().startOf('day'), moment().set({ hour: 23, minute: 59, second: 0 })]
        };
        // this.selectedRange = {
        //   startDate: moment().startOf('day'),
        //   endDate: moment().set({ hour: 23, minute: 59, second: 0 })        };
        console.log(this.selectedRange, 'this.selectedRange');
        this.cdr.detectChanges();
    },0)
    }
  }



  
  


 
}


// get days from months

// ...1
// const getDays = (year, month) => {
//   return new Date(year, month, 0).getDate();
// };
// const daysInSeptember = getDays(2021, 7);

// ...2
// const daysInSeptember = getDays(new Date().getFullYear(), 7);
